import React from "react";
import Select, { components } from "react-select";

const searchTypeCustomStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    width: "100%",
    backgroundColor: "#fff",
    borderRadius: "4px",
    fontSize: "14px",
    fontWeight: 600,
    textAlign: "left",
    border: "none",
    outline: state.isFocused ? "1px solid #6F08F1" : "1px solid #e4e7eb",
    "&:hover": {
      outline: "1px solid #6F08F1",
    },
  }),
  menu: (base) => ({
    ...base,
    fontSize: "14px",
    zIndex: 9999,
  }),
  singleValue: (base) => ({
    ...base,
    fontWeight: "400",
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "darkgray",
      fontWeight: 400,
    };
  },
  MultiValueRemove: (defaultStyles) => ({
    ...defaultStyles,
    backgroundColor: "#E2D9FC",
    color: "#6F08F1",
  }),
  option: (base, { isDisabled, isFocused, isSelected, isHovered }) => ({
    ...base,
    backgroundColor: null,
    color: isDisabled ? null : isSelected ? "#1a1722" : isFocused ? "#1a1722" : null,
    cursor: "pointer !important",
    textAlign: "left",
  }),
};

const parentCustomComponents = {
  IndicatorSeparator: () => null,
};

const SingleDropdown = ({ options, onChangeHandler, item, index, parentData, placeholder, value }) => {
  return (
    <div>
      <Select
        options={options}
        isClearable
        styles={searchTypeCustomStyles}
        placeholder={placeholder}
        // closeMenuOnSelect={false}
        isSearchable={true}
        // menuIsOpen={true}
        hideSelectedOptions={false}
        value={value ? value : null}
        components={parentCustomComponents}
        onChange={(value) => onChangeHandler(value, item, index, parentData)}
      />
    </div>
  );
};

export default SingleDropdown;
